import React, {useEffect} from 'react';
import {Outlet, useNavigate, useSearchParams} from 'react-router-dom';
import {useTranslation} from 'react-i18next';
import {Box, Center, HStack, useColorMode} from '@chakra-ui/react';
import LanguageBtn from 'components/LanguageBtn';
import ColorModeBtn from 'components/ColorModeBtn';
import {useColorModeValueKey} from 'hooks/useColors';
import Page from 'components/Page';
import {usePlatformBasicInfo} from 'hooks/datahook/auth';
import {useInIframe} from 'hooks/useInIFrame';
import referralBg from 'assets/images/guestBg.jpg';

const EdgeCaseLayout = (props) => {
    const {t, i18n} = useTranslation('app');
    const {data: basicInfo, isLoading} = usePlatformBasicInfo();
    const {colorMode, setColorMode} = useColorMode();
    // console.log(colorMode);
    const inIframe = useInIframe();
    const [searchParams] = useSearchParams();
    const defaultColorMode = searchParams.get('colorMode');
    const defaultLang = searchParams.get('lang');
    useEffect(() => {
        if (
            defaultColorMode &&
            defaultColorMode !== colorMode &&
            ['light', 'dark'].includes(defaultColorMode)
        ) {
            setColorMode(defaultColorMode);
        }
    }, [defaultColorMode]);

    useEffect(() => {
        if (
            defaultLang &&
            i18n.language !== defaultLang &&
            ['en-US', 'zh-CN', 'zh-TW', 'jp-JP'].includes(defaultLang)
        ) {
            i18n.changeLanguage(defaultLang);
        }
    }, [defaultLang]);
    return (
        <Page title={isLoading ? t('loading') : basicInfo.companyShortName}>
            <Box
                position={'relative'}
                width={'100vw'}
                bg={
                    colorMode === 'dark'
                        ? '#101010'
                        : useColorModeValueKey('bg')
                }
                transition="background-color 200ms linear"
            >
                {inIframe ? null : (
                    <HStack
                        position={'absolute'}
                        alignItems={'flex-end'}
                        justifyContent={'flex-end'}
                        right={8}
                        top={4}
                        spacing={2}
                        w={'100vw'}
                    >
                        <LanguageBtn />
                        <ColorModeBtn />
                    </HStack>
                )}
                <Center
                    alignItems={'center'}
                    justifyContent={'center'}
                    // position={'absolute'}
                    width={'100vw'}
                    height={'100vh'}
                    // bg={useColorModeValueKey('bg')}
                >
                    <Outlet />
                </Center>
            </Box>
        </Page>
    );
};

export default EdgeCaseLayout;
